export default __webpack_public_path__ + "static/media/west.925262ee.svg";